export const capitalize = (word: string): string =>
  word[0].toUpperCase() + word.slice(1).toLowerCase();
